import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { lastValueFrom } from 'rxjs';
import { CargoConfigModel, ConfigModel } from './model';

@Injectable({
    providedIn: 'root'
})
export class AppConfigService {
    private appConfig!: CargoConfigModel;

    constructor(private http: HttpClient) {

    }

    async loadAppConfig() {
        let configURL!: string;
        const currentDate = Date.now();

        if (environment.production) {
            configURL = `/public/assets/config/config.json?v=${currentDate}`;
        } else {
            configURL = `../assets/config/config.json?v=${currentDate}`;
        }

        const configObservable = this.http.get<ConfigModel>(configURL, { responseType: 'json' });
        const config = await lastValueFrom<ConfigModel>(configObservable);
        const currentURL = window.location.href;


        for (let i = 0; i < config.sites.length; i++) {
            if (currentURL.startsWith(config.sites[i].url)) {
                this.appConfig = config.sites[i].config;
                this.appConfig.api = this.appConfig.api ? this.appConfig.api : config.api;
                this.appConfig.trackingId = this.appConfig.trackingId ? this.appConfig.trackingId : config.trackingId;
                this.appConfig.logAPI = this.appConfig.logAPI ? this.appConfig.logAPI : config.logAPI;
                this.appConfig.logLevel = this.appConfig.logLevel ? this.appConfig.logLevel : config.logLevel;

                console.log(`Loaded configuration for: ${config.sites[i].url}`);
                break;
            }
        }
    }

    getConfig() {
        return this.appConfig;
    }

    getValue(key: string): any {
        type ObjectKey = keyof typeof this.appConfig;
        return this.appConfig[key as ObjectKey];
    }
}